import { useState, useEffect } from 'react';

const getItemsIniciales = (usuario) => {
    const equipos = usuario?.equiposAsignados ?? [];
    // Si tiene equipos precargados úsalos, si no un solo row vacío
    const activos = equipos.length > 0
        ? equipos.map((e, i) => ({
            id: i + 1,
            activo: e.activo ?? '',
            marca_modelo: e.marca_modelo ?? '',
            numero_serie: e.numero_serie ?? '',
            estado: null,
        }))
        : [{ id: 1, activo: '', marca_modelo: '', numero_serie: '', estado: null }];

    return {
        tipoSalida: null,
        activos,
        bloqueo_cuentas: false,
        respaldo_info: false,
        desinstalacion_sw: false,
        reasignacion_correo: false,
        resultado: null,
        observaciones: '',
    };
};

export default function ModalChecklist({ usuario, onConfirm, onClose }) {
    const [form, setForm] = useState(() => getItemsIniciales(usuario));

    useEffect(() => {
        setForm(getItemsIniciales(usuario));
    }, [usuario?.id]);

    if (!usuario) return null;

    const setActivo = (id, campo, valor) => {
        setForm(f => ({
            ...f,
            activos: f.activos.map(a => a.id === id ? { ...a, [campo]: valor } : a)
        }));
    };

    const toggle = (campo) => setForm(f => ({ ...f, [campo]: !f[campo] }));

    return (
        <div className="overlay" onClick={onClose}>
            <div className="modal" onClick={e => e.stopPropagation()}
                style={{ width: 680, maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>

                {/* Header */}
                <div style={{ flexShrink: 0, borderBottom: '1px solid #ddd', paddingBottom: 12, marginBottom: 12 }}>
                    <h3 style={{ margin: 0 }}>Acta de Paz y Salvo Técnica</h3>
                    <span style={{ fontSize: 12, color: '#888' }}>TI-FOR-02 — {usuario.nombre_completo}</span>
                </div>

                <div style={{ overflowY: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: 20 }}>

                    {/* I. Tipo de salida */}
                    <section>
                        <h4 style={{ margin: '0 0 8px', color: '#1e6378', fontSize: 13 }}>I. DATOS GENERALES</h4>
                        <div style={{ fontSize: 13, marginBottom: 8 }}>
                            <b>Nombre:</b> {usuario.nombre_completo} &nbsp;|&nbsp;
                            <b>Puesto:</b> {usuario.puesto ?? '—'} &nbsp;|&nbsp;
                            <b>Área:</b> {usuario.area_nombre ?? '—'}
                        </div>
                        <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                            <span style={{ fontSize: 13 }}>Tipo de salida:</span>
                            {['planeada', 'no_planeada'].map(tipo => (
                                <label key={tipo} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer' }}>
                                    <input type="radio" name="tipoSalida" checked={form.tipoSalida === tipo}
                                        onChange={() => setForm(f => ({ ...f, tipoSalida: tipo }))} />
                                    {tipo === 'planeada' ? 'Planeada' : 'No Planeada'}
                                </label>
                            ))}
                        </div>
                    </section>

                    {/* II. Activos físicos */}
                    <section>
                        <h4 style={{ margin: '0 0 8px', color: '#1e6378', fontSize: 13 }}>II. VERIFICACIÓN DE ACTIVOS FÍSICOS</h4>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                            <thead>
                                <tr style={{ background: '#1e6378', color: 'white' }}>
                                    <th style={{ padding: '6px 8px', textAlign: 'left' }}>Activo</th>
                                    <th style={{ padding: '6px 8px', textAlign: 'left' }}>Marca / Modelo</th>
                                    <th style={{ padding: '6px 8px', textAlign: 'left' }}>N° Serie</th>
                                    <th style={{ padding: '6px 8px', textAlign: 'left' }}>Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {form.activos.map(a => (
                                    <tr key={a.id} style={{ borderBottom: '1px solid #eee' }}>
                                        <td style={{ padding: '4px 6px' }}>
                                            <input className="form-input" style={{ padding: '3px 6px', fontSize: 12 }}
                                                placeholder="Ej: Laptop" value={a.activo}
                                                onChange={e => setActivo(a.id, 'activo', e.target.value)} />
                                        </td>
                                        <td style={{ padding: '4px 6px' }}>
                                            <input className="form-input" style={{ padding: '3px 6px', fontSize: 12 }}
                                                placeholder="Dell XPS / 15" value={a.marca_modelo}
                                                onChange={e => setActivo(a.id, 'marca_modelo', e.target.value)} />
                                        </td>
                                        <td style={{ padding: '4px 6px' }}>
                                            <input className="form-input" style={{ padding: '3px 6px', fontSize: 12 }}
                                                placeholder="N/S" value={a.numero_serie}
                                                onChange={e => setActivo(a.id, 'numero_serie', e.target.value)} />
                                        </td>
                                        <td style={{ padding: '4px 6px' }}>
                                            <div style={{ display: 'flex', gap: 8 }}>
                                                {['optimo', 'dano'].map(est => (
                                                    <label key={est} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, cursor: 'pointer' }}>
                                                        <input type="radio" name={`estado_${a.id}`} checked={a.estado === est}
                                                            onChange={() => setActivo(a.id, 'estado', est)} />
                                                        {est === 'optimo' ? 'Óptimo' : 'Daño'}
                                                    </label>
                                                ))}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan={4} style={{ padding: '6px 4px' }}>
                                        <button type="button" className="btn-secondary"
                                            style={{ fontSize: 11, padding: '3px 10px' }}
                                            onClick={() => setForm(f => ({
                                                ...f,
                                                activos: [...f.activos, {
                                                    id: f.activos.length + 1,
                                                    activo: '', marca_modelo: '', numero_serie: '', estado: null
                                                }]
                                            }))}>
                                            + Agregar fila
                                        </button>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </section>

                    {/* III. Activos intangibles */}
                    <section>
                        <h4 style={{ margin: '0 0 8px', color: '#1e6378', fontSize: 13 }}>III. GESTIÓN DE ACTIVOS INTANGIBLES</h4>
                        {[
                            { key: 'bloqueo_cuentas', label: 'Bloqueo de Cuentas: Desactivación de correo y accesos a sistemas' },
                            { key: 'respaldo_info', label: 'Respaldo de Información: Copia de archivos locales y nubes corporativas' },
                            { key: 'desinstalacion_sw', label: 'Desinstalación de Software: Eliminación de programas y licencias corporativas' },
                            { key: 'reasignacion_correo', label: 'Reasignación de Correo: Confirmación de reasignación del buzón al encargado' },
                        ].map(item => (
                            <label key={item.key} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 8, cursor: 'pointer', fontSize: 13 }}>
                                <input type="checkbox" checked={form[item.key]} onChange={() => toggle(item.key)}
                                    style={{ marginTop: 2, flexShrink: 0 }} />
                                {item.label}
                            </label>
                        ))}
                    </section>

                    {/* IV. Dictamen */}
                    <section>
                        <h4 style={{ margin: '0 0 8px', color: '#1e6378', fontSize: 13 }}>IV. DICTAMEN TÉCNICO FINAL</h4>
                        <div style={{ display: 'flex', gap: 16, marginBottom: 12 }}>
                            {[
                                { val: 'paz_y_salvo', label: 'PAZ Y SALVO', color: '#28a745' },
                                { val: 'no_conformidad', label: 'NO CONFORMIDAD', color: '#dc3545' },
                            ].map(op => (
                                <label key={op.val} style={{
                                    display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer',
                                    padding: '6px 12px', borderRadius: 4, border: `1.5px solid ${form.resultado === op.val ? op.color : '#ccc'}`,
                                    background: form.resultado === op.val ? `${op.color}15` : 'transparent', fontWeight: form.resultado === op.val ? 500 : 400
                                }}>
                                    <input type="radio" name="resultado" checked={form.resultado === op.val}
                                        onChange={() => setForm(f => ({ ...f, resultado: op.val }))} />
                                    {op.label}
                                </label>
                            ))}
                        </div>
                        <label style={{ fontSize: 12, color: '#666', display: 'block', marginBottom: 4 }}>Observaciones y hallazgos:</label>
                        <textarea className="form-input" rows={3} style={{ resize: 'vertical', fontSize: 13 }}
                            placeholder="Descripción de daños, pendientes o irregularidades..."
                            value={form.observaciones}
                            onChange={e => setForm(f => ({ ...f, observaciones: e.target.value }))} />
                    </section>
                </div>

                {/* Footer */}
                <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end', marginTop: 16, flexShrink: 0, borderTop: '1px solid #ddd', paddingTop: 12 }}>
                    <button className="btn-secondary" onClick={onClose}>Cancelar</button>
                    <button className="btn-primary" onClick={() => onConfirm(form)}
                        disabled={!form.tipoSalida || !form.resultado}>
                        Generar acta
                    </button>
                </div>
            </div>
        </div>
    );
}